import React, {useEffect, useState} from 'react';
import {IonContent, IonPage} from '@ionic/react';
import {useHistory} from 'react-router-dom';
import {ApiService} from "../api/ApiService";
import {Trainee} from "../api/model/Trainee";
import {toastStore} from "../components/AppToast";
import LoadDetailHeader, {useTransparentHeaderContrast} from '../components/LoadDetailHeader';
import {ChevronRight} from '../components/icons';

function TrainerFeedback() {
    const history = useHistory();
    const {onSheet, onIonScroll} = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);
    const [showProfile, setShowProfile] = useState(false);

    const [overallScore, setOverallScore] = useState('');
    const [overallExp, setOverallExp] = useState('');
    const [cleanliness, setCleanliness] = useState('');
    const [policyScore, setPolicyScore] = useState('');
    const [conductScore, setConductScore] = useState('');
    const [dotReg, setDotReg] = useState('');
    const [logTraining, setLogTraining] = useState('');
    const [refWEXP, setRefWEXP] = useState('');
    const [refTrainer, setRefTrainer] = useState('');
    const [complaint, setComplaint] = useState('');
    const [comments, setComments] = useState<string>('');
    const [trainee, setTrainee] = useState<Trainee>({} as Trainee);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        ApiService.getTraineeProfile('trainerFeedback').then(it => {
            setTrainee(it);
        });
    }, []);

    const surveyNumResp = [
        {question: "Rate overall experience on the trainer's truck:", value: overallScore, func: setOverallScore},
        {question: "Rate cleanliness of inside the truck:", value: cleanliness, func: setCleanliness},
        {question: "Trainer knowledge of Western Express policies?", value: policyScore, func: setPolicyScore},
        {question: "Rate professinalism of trainer:", value: conductScore, func: setConductScore},
        {question: "Rate effectiveness of log training:", value: logTraining, func: setLogTraining},
        {question: "Rate overall training experience:", value: overallExp, func: setOverallExp},
    ]

    const surveyBoolResp = [
        {question: "Would you reccommend trainer to other trainees?", value: refWEXP, func: setRefWEXP},
        {question: "Would you reccommend Western Express to other drivers?", value: refTrainer, func: setRefTrainer},
        {question: "Does the training reflect the importance of DOT Rules & Regulation(s)?", value: dotReg, func: setDotReg},
        {question: "At any point, did the trainer cause you to feel uncomfortable?", value: complaint, func: setComplaint},
    ]

    async function submitFeedback() {
        if (submitting) return;
        setSubmitting(true);
        ApiService.submitTrainerFeedback("trainerFeedback", {
            traineeCode: trainee.traineeCode,
            trainerCode: trainee.trainerCode,
            overallScore: overallScore,
            cleanliness: cleanliness,
            policyScore: policyScore,
            conductScore: conductScore,
            logTraining: logTraining,
            overallExp: overallExp,
            dotReg: dotReg,
            refWEXP: refWEXP,
            refTrainer: refTrainer,
            complaint: complaint,
            comments: comments
        }).then(() => {
            toastStore.getState().setSuccessToast('Success! - Report Submited ...');
            history.push('/home');
        }).catch(() => {
            toastStore.getState().setToast('Your feedback could not be submitted. Please check your connection and try again.');
            setSubmitting(false);
        });
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Home');
    };

    return (
        <IonPage>
            <LoadDetailHeader title="Course Survey" onBack={goBack} onSheet={onSheet} />

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero advance-hero">
                  <div className="advance-hero__eyebrow">Training</div>
                  <div className="advance-hero__title home-display">Course Survey</div>
                  <div className="advance-hero__meta">Driver trainer feedback</div>
                </div>

                <div className="home-sheet advance-sheet">
                  <button type="button" className="home-action" onClick={() => setShowProfile(!showProfile)}>
                    <span className="home-action__label">Trainee Profile</span>
                    <ChevronRight />
                  </button>

                  {showProfile ? (
                    <div className="home-card">
                      <div className="training-meta-card">
                        <div className="training-meta-card__row">
                          <span className="training-meta-card__label">Trainee</span>
                          <span className="training-meta-card__value">{trainee.traineeName} ({trainee.traineeCode})</span>
                        </div>
                        <div className="training-meta-card__divider" />
                        <div className="training-meta-card__row">
                          <span className="training-meta-card__label">Trainer</span>
                          <span className="training-meta-card__value">{trainee.trainerName} ({trainee.trainerCode})</span>
                        </div>
                        <div className="training-meta-card__divider" />
                        <div className="training-meta-card__row">
                          <span className="training-meta-card__label">DM Code</span>
                          <span className="training-meta-card__value">{trainee.dmCode}</span>
                        </div>
                        <div className="training-meta-card__divider" />
                        <div className="training-meta-card__row">
                          <span className="training-meta-card__label">Current Course (Day)</span>
                          <span className="training-meta-card__value">{trainee.currentCourseDay}</span>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  <div className="home-card training-info-card">
                    <div className="training-info-card__label">Driver Trainer Feedback</div>
                    <p className="training-info-card__body">
                      1 = Very poor · 5 = Very good. Please rate each of the following questions with
                      responses 1–5.
                    </p>
                  </div>

                  <div className="home-section-label">Rate your experience</div>
                  <div className="profile-fields">
                    {surveyNumResp.map((element, index) => (
                      <label className="profile-field" key={index}>
                        <span className="profile-field__label">{element.question}</span>
                        <select
                          id={"numResp_" + index}
                          className="profile-field__input profile-field__input--select"
                          value={element.value}
                          onChange={e => element.func(e.target.value)}
                        >
                          <option value="" disabled>Select a rating</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </label>
                    ))}
                  </div>

                  <div className="home-section-label">Overall experience</div>
                  <div className="profile-fields">
                    {surveyBoolResp.map((element, index) => (
                      <div className="home-card" key={index}>
                        <div className="training-info-card__body" style={{marginBottom: 10}}>{element.question}</div>
                        <div className="brokerage-segment">
                          <button
                            type="button"
                            className={`brokerage-segment__btn${element.value === '1' ? ' is-active' : ''}`}
                            onClick={() => element.func('1')}
                          >
                            <span className="brokerage-segment__label">Yes</span>
                          </button>
                          <button
                            type="button"
                            className={`brokerage-segment__btn${element.value === '0' ? ' is-active' : ''}`}
                            onClick={() => element.func('0')}
                          >
                            <span className="brokerage-segment__label">No</span>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <label className="profile-field">
                    <span className="profile-field__label">Comments</span>
                    <textarea
                      id="western"
                      className="profile-field__input"
                      rows={4}
                      maxLength={200}
                      value={comments}
                      onChange={e => setComments(e.target.value)}
                      placeholder="Max of 200 Characters ..."
                    />
                  </label>

                  <button type="button" className="profile-submit" disabled={submitting} onClick={() => submitFeedback()}>
                    Submit
                  </button>
                </div>
              </div>
            </IonContent>
        </IonPage>
    );
}

export default TrainerFeedback;
